import { render, staticRenderFns } from "./DetailCommunication.vue?vue&type=template&id=3bcfa8b7&scoped=true"
import script from "./DetailCommunication.vue?vue&type=script&lang=js"
export * from "./DetailCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcfa8b7",
  null
  
)

export default component.exports